import { useEffect, useRef } from "react";

interface UseTableStylesProps {
  rowsToStyle: number[];
  bgColor?: string;
  borderColor?: string;
}

const useTableStyles = ({
  rowsToStyle,
  bgColor = "#FFF8C599",
  borderColor = "#D4A72C66",
}: UseTableStylesProps) => {
  const styleElementRef = useRef<HTMLStyleElement | null>(null);

  useEffect(() => {
    const styleText = `
      :root {
        ${rowsToStyle
          .map((index) => `--row-${index}-bg-color: ${bgColor};`)
          .join("\n")}
      }
      ${rowsToStyle
        .map(
          (index) => `
        .TableRow:nth-child(${index}) {
          background-color: var(--row-${index}-bg-color) !important;
        }
        .TableRow:nth-child(${index}) td {
          border-bottom: 1px solid ${borderColor} !important;
        }
        .TableRow:nth-child(${index}) th {
          border-bottom: 1px solid ${borderColor} !important;
        }
      `
        )
        .join("\n")}
    `;

    const styleElement = document.createElement("style");
    styleElement.innerHTML = styleText;
    styleElementRef.current = styleElement;
    document.head.appendChild(styleElement);

    return () => {
      if (styleElementRef.current) {
        document.head.removeChild(styleElementRef.current);
      }
    };
  }, [rowsToStyle, bgColor, borderColor]);

  const removeStyles = () => {
    if (styleElementRef.current) {
      document.head.removeChild(styleElementRef.current);
      styleElementRef.current = null;
    }
  };

  return { removeStyles };
};

export default useTableStyles;
